module.exports = __webpack_public_path__ + "static/media/photo11.0180ae4f.jpg";